import type { MouseEvent } from 'react'
import { IconButton, Tooltip } from '@mui/material'
import OpenInFullIcon from '@mui/icons-material/OpenInFull'
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen'
import { CHAT_STRINGS } from '../strings'

type TChatSizeButtonProps = {
  expanded: boolean
  onToggle: (event: MouseEvent<HTMLButtonElement>) => void
}

export const ChatSizeButton = ({ expanded, onToggle }: TChatSizeButtonProps) => {
  const text = expanded ? CHAT_STRINGS.collapse : CHAT_STRINGS.expand
  return (
    <Tooltip title={text}>
      <IconButton onClick={onToggle} size="small" aria-label={text}>
        {expanded ? <CloseFullscreenIcon fontSize="small" /> : <OpenInFullIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  )
}
